import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export const jackpotStoreInitialValues = {
  jackpots: [],
  jackpotGameIds: [],
  jackpotCurrenciesGameIds: {}
}

export const useJackpotsStore = create(
  devtools(set => ({
    jackpotsData: jackpotStoreInitialValues,
    setJackpotsData: jackpotsData => set(() => ({ jackpotsData: jackpotsData }), false, 'setJackpotsData')
  }))
)
